import HandleNewCompletionForm from "./HandleNewCompletionForm";

function FormNewCompletion({ completions, onDataChange, filters,setView }) {
    return <HandleNewCompletionForm completions={completions} filters={filters} onDataChange={onDataChange} setView={setView} />
}

export default FormNewCompletion;